import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";

export function BreadcrumbItem({
  label,
  icon,
  active = false,
  disabled = false,
  onClick = () => {},
}: {
  label: string;
  icon: IconDefinition;
  active?: boolean;
  disabled?: boolean;
  onClick?: () => void;
}) {
  return (
    <button
      onClick={onClick}
      className={classNames(
        "tw-flex tw-cursor-pointer tw-items-center tw-gap-2 tw-rounded-md tw-border-none tw-px-2 tw-py-1 tw-transition-all tw-duration-75 disabled:tw-cursor-default disabled:tw-opacity-60",
        {
          "tw-bg-transparent hover:tw-bg-white-dark active:tw-bg-white-mid": !active && !disabled,
          "tw-bg-[#F3FBFF] tw-font-bold tw-text-primary hover:tw-bg-[#deeffa] active:tw-bg-[#c2daed]":
            active && !disabled,
        },
      )}
      disabled={disabled}
    >
      <FontAwesomeIcon
        icon={icon}
        className={classNames({
          "tw-text-text-secondary": !active,
        })}
      />
      <span
        className={classNames({
          "tw-text-text-secondary": !active,
        })}
      >
        {label}
      </span>
    </button>
  );
}
